module.exports = __webpack_public_path__ + "static/media/event.7b34fcaa.svg";